import { type GenericListQueryKey, generateInfiniteQueryKey, generateListQueryKey } from '@pba/react-query';
import { medicalGroupsFeatureKey } from '../../key';
import type { CohortsListQueryFilter, CohortsListQuerySorter } from './types';

type CohortsListQueryType = GenericListQueryKey<CohortsListQueryFilter, CohortsListQuerySorter>;

export const cohortsFeatureKey = ['cohorts'] as const;

export const getCohortsListQueryKey = (params: CohortsListQueryType) =>
  generateListQueryKey({
    prefix: [...medicalGroupsFeatureKey, ...cohortsFeatureKey],
  })(params);

export const getCohortsInfiniteQueryKey = generateInfiniteQueryKey({
  generateListQueryKey: getCohortsListQueryKey,
});
